import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './CertificatePage.module.css';

const COA_DATA = {
  issuedOn: 'September 17, 2026',
  artwork: {
    title: 'Su-STAINED, Volume 2',
    medium: 'Acrylic, Gold Luxer Wax',
    size: '24 in x 48 in',
    year: '2026',
    edition: 'Volume 2 / Original : 1 of 1',
    image: '/images/coa/su-stained-volume-2.jpg',
  },
  artist: {
    name: 'Jamelly Ervin',
    email: 'hello@jamelly.art',
  },
  declaration: [
    'This document certifies that Su-STAINED Volume 2 is an original artwork created by Jamelly Ervin. It is a one-of-a-kind commissioned piece, and any reproductions require explicit permission from the artist.',
    'All rights remain with the artist. Unauthorized copying or distribution is strictly prohibited.',
  ],
};

const CertificateSuStainedV2 = () => {
  const [copied, setCopied] = useState(false);

  const handlePrint = () => {
    window.print();
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy link:', err);
    }
  };

  return (
    <>
      <Helmet>
        <title>Certificate of Authenticity — {COA_DATA.artwork.title} | Jamelly</title>
        <meta
          name="description"
          content={`Official Certificate of Authenticity for ${COA_DATA.artwork.title} by ${COA_DATA.artist.name}.`}
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className={styles.page}>
        <div className={styles.certificate}>
          <div className={styles.actions}>
            <button type="button" onClick={handlePrint} className={styles.button}>
              Print / Save
            </button>
            <button type="button" onClick={handleCopyLink} className={styles.button}>
              {copied ? 'Copied!' : 'Copy Link'}
            </button>
          </div>

          <div className={styles.layout}>
            <section className={styles.detailsPanel}>
              <header className={styles.header}>
                <h1 className={styles.title}>Certificate of Authenticity</h1>
                <div className={styles.titleRule} aria-hidden="true" />
              </header>

              <div className={styles.section}>
                <h2 className={styles.sectionLabel}>Artwork Details</h2>
                <dl className={styles.detailList}>
                  <div className={styles.detailRow}>
                    <dt>Title</dt>
                    <dd>{COA_DATA.artwork.title}</dd>
                  </div>
                  <div className={styles.detailRow}>
                    <dt>Medium</dt>
                    <dd>{COA_DATA.artwork.medium}</dd>
                  </div>
                  <div className={styles.detailRow}>
                    <dt>Size</dt>
                    <dd>{COA_DATA.artwork.size}</dd>
                  </div>
                  <div className={styles.detailRow}>
                    <dt>Year</dt>
                    <dd>{COA_DATA.artwork.year}</dd>
                  </div>
                  <div className={styles.detailRow}>
                    <dt>Edition</dt>
                    <dd>{COA_DATA.artwork.edition}</dd>
                  </div>
                </dl>
              </div>

              <div className={styles.section}>
                <h2 className={styles.sectionLabel}>Artist Information</h2>
                <dl className={styles.detailList}>
                  <div className={styles.detailRow}>
                    <dt>Artist</dt>
                    <dd>{COA_DATA.artist.name}</dd>
                  </div>
                  <div className={styles.detailRow}>
                    <dt>Issued on</dt>
                    <dd>{COA_DATA.issuedOn}</dd>
                  </div>
                  <div className={styles.detailRow}>
                    <dt>Contact</dt>
                    <dd>
                      <a href={`mailto:${COA_DATA.artist.email}`}>
                        {COA_DATA.artist.email}
                      </a>
                    </dd>
                  </div>
                </dl>
              </div>

              <div className={styles.section}>
                <h2 className={styles.sectionLabel}>Authenticity Declaration</h2>
                {COA_DATA.declaration.map((paragraph) => (
                  <p key={paragraph.slice(0, 24)} className={styles.declaration}>
                    {paragraph}
                  </p>
                ))}
              </div>
            </section>

            <aside className={styles.visualPanel}>
              <div className={styles.artworkFrame}>
                <img
                  src={COA_DATA.artwork.image}
                  alt={COA_DATA.artwork.title}
                  className={styles.artworkImage}
                />
              </div>

              <p className={styles.verification}>
                For verification, please contact{' '}
                <a href={`mailto:${COA_DATA.artist.email}`}>
                  {COA_DATA.artist.email}
                </a>
              </p>
            </aside>
          </div>
        </div>
      </div>
    </>
  );
};

export default CertificateSuStainedV2;
